document.addEventListener('DOMContentLoaded', function () {
  var block8 = document.querySelector('[id*=pdp_content]');
  var hero = document.querySelector('.pdp-hero');
  if (!block8 || !hero) return;

  var products = [
    {
      handle: 'rutam-revitalizing-scalp-mist',
      step: 'STEP 1',
      shortName: 'SCALP & VOLUME MIST',
      purpose: 'Refresh the scalp surface and lift the roots.',
      price: '$65.00',
      image: 'https://cdn.shopify.com/s/files/1/0953/0897/2325/files/IMG_6417.jpg?v=1757969202&width=900',
      accent: '#BCC98A'
    },
    {
      handle: 'rutam-no8-intensive-hair-serum',
      step: 'STEP 2',
      shortName: 'Nº8 INTENSIVE SERUM',
      purpose: 'Support softness, manageability and fuller-looking hair.',
      price: '$68.00',
      image: 'https://cdn.shopify.com/s/files/1/0953/0897/2325/files/IMG_8273.jpg?v=1762654382&width=900',
      accent: '#E89A6C'
    },
    {
      handle: 'rutam-360-pro-shield',
      step: 'STEP 3',
      shortName: '360º PRO SHIELD',
      purpose: 'Protect vulnerable lengths before and after service.',
      price: '$75.00',
      image: 'https://cdn.shopify.com/s/files/1/0953/0897/2325/files/IMG_7134.jpg?v=1770644837&width=900',
      accent: '#EEC3AB'
    }
  ];

  var currentHandle = window.location.pathname.split('/products/')[1] || '';
  currentHandle = currentHandle.split('?')[0].split('#')[0];

  function findBlock(label) {
    for (var i = 0; i < block8.children.length; i += 1) {
      var node = block8.children[i];
      var marker = node.querySelector('.pdp-block__label');
      if (marker && marker.textContent.trim().indexOf(label) === 0) return node;
    }
    return null;
  }

  function moneyFromCents(cents) {
    if (typeof cents !== 'number') return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function hydratePrice(product, priceNode) {
    fetch('/products/' + product.handle + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product fetch failed');
        return response.json();
      })
      .then(function (data) {
        if (data && typeof data.price === 'number') {
          priceNode.textContent = moneyFromCents(data.price);
        }
      })
      .catch(function () {});
  }

  function createCard(product, mode) {
    var isCurrent = product.handle === currentHandle;
    var card = document.createElement(isCurrent ? 'div' : 'a');
    card.className = 'rutam-visual-card rutam-visual-card--' + mode + (isCurrent ? ' is-current' : '');
    card.style.setProperty('--rutam-card-accent', product.accent);

    if (isCurrent) {
      card.setAttribute('aria-current', 'page');
    } else {
      card.href = '/products/' + product.handle;
      card.setAttribute('aria-label', 'View ' + product.shortName);
    }

    var media = document.createElement('div');
    media.className = 'rutam-visual-card__media';

    var img = document.createElement('img');
    img.src = product.image;
    img.alt = 'RUTAM ' + product.shortName + ' product';
    img.loading = mode === 'rail' ? 'eager' : 'lazy';
    img.decoding = 'async';
    media.appendChild(img);

    var step = document.createElement('span');
    step.className = 'rutam-visual-card__step';
    step.textContent = product.step;
    media.appendChild(step);

    if (isCurrent) {
      var current = document.createElement('span');
      current.className = 'rutam-visual-card__current';
      current.textContent = 'YOU ARE HERE';
      media.appendChild(current);
    }

    var body = document.createElement('div');
    body.className = 'rutam-visual-card__body';

    var title = document.createElement('h3');
    title.className = 'rutam-visual-card__title';
    title.textContent = product.shortName;
    body.appendChild(title);

    if (mode === 'gallery') {
      var purpose = document.createElement('p');
      purpose.className = 'rutam-visual-card__purpose';
      purpose.textContent = product.purpose;
      body.appendChild(purpose);
    }

    var foot = document.createElement('div');
    foot.className = 'rutam-visual-card__foot';

    var price = document.createElement('span');
    price.className = 'rutam-visual-card__price';
    price.textContent = product.price;
    foot.appendChild(price);
    hydratePrice(product, price);

    var action = document.createElement('span');
    action.className = 'rutam-visual-card__action';
    action.textContent = isCurrent ? 'CURRENT STEP' : 'VIEW PRODUCT →';
    foot.appendChild(action);

    body.appendChild(foot);
    card.appendChild(media);
    card.appendChild(body);
    return card;
  }

  function buildRail() {
    var existing = document.querySelector('.rutam-product-rail');
    if (existing) existing.remove();

    var rail = document.createElement('section');
    rail.className = 'rutam-product-rail';
    rail.setAttribute('aria-label', 'The RUTAM System');

    var head = document.createElement('div');
    head.className = 'rutam-product-rail__head';

    var kicker = document.createElement('span');
    kicker.className = 'rutam-product-rail__kicker';
    kicker.textContent = 'THE RUTAM SYSTEM';
    head.appendChild(kicker);

    var note = document.createElement('span');
    note.className = 'rutam-product-rail__note';
    note.textContent = 'Move directly between all three steps.';
    head.appendChild(note);

    var track = document.createElement('div');
    track.className = 'rutam-product-rail__track';
    products.forEach(function (product) {
      track.appendChild(createCard(product, 'rail'));
    });

    rail.appendChild(head);
    rail.appendChild(track);
    hero.after(rail);
  }

  function buildGallery() {
    var completeBlock = findBlock('The Complete System');
    if (!completeBlock) return;

    var oldGrid = completeBlock.querySelector('.routine-grid');
    if (oldGrid) oldGrid.style.display = 'none';

    var existing = completeBlock.querySelector('.rutam-system-gallery');
    if (existing) existing.remove();

    var gallery = document.createElement('div');
    gallery.className = 'rutam-system-gallery';

    products.forEach(function (product) {
      gallery.appendChild(createCard(product, 'gallery'));
    });

    completeBlock.appendChild(gallery);
  }

  var goDeeper = findBlock('Go Deeper');
  if (goDeeper) goDeeper.style.display = 'none';

  buildRail();
  buildGallery();

  var style = document.createElement('style');
  style.id = 'rutam-image-led-funnel-style';
  style.textContent = '\
    .rutam-product-rail{background:#160d08;border-top:1px solid rgba(245,242,236,.08);border-bottom:1px solid rgba(245,242,236,.08);padding:30px 28px 34px;color:#f5f2ec}\
    .rutam-product-rail__head{max-width:1180px;margin:0 auto 18px;display:flex;justify-content:space-between;align-items:end;gap:20px}\
    .rutam-product-rail__kicker{font-family:"DM Sans",sans-serif;font-size:10px;letter-spacing:.22em;color:#c8cfc4;text-transform:uppercase}\
    .rutam-product-rail__note{font-family:"DM Sans",sans-serif;font-size:12px;color:rgba(245,242,236,.48)}\
    .rutam-product-rail__track,.rutam-system-gallery{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:18px;max-width:1180px;margin:0 auto}\
    .rutam-visual-card{position:relative;display:grid;grid-template-columns:150px 1fr;min-height:170px;background:#21150f;border:1px solid rgba(245,242,236,.12);color:#f5f2ec;text-decoration:none;overflow:hidden;transition:transform .35s ease,border-color .35s ease,box-shadow .35s ease}\
    .rutam-visual-card:hover{transform:translateY(-4px);border-color:var(--rutam-card-accent);box-shadow:0 18px 40px rgba(0,0,0,.28)}\
    .rutam-visual-card.is-current{border-color:var(--rutam-card-accent);box-shadow:inset 0 0 0 1px var(--rutam-card-accent)}\
    .rutam-visual-card__media{position:relative;min-height:170px;background:linear-gradient(160deg,#33241a,#160d08);overflow:hidden}\
    .rutam-visual-card__media:after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,transparent 45%,rgba(5,3,2,.56))}\
    .rutam-visual-card__media img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .5s ease}\
    .rutam-visual-card:hover .rutam-visual-card__media img{transform:scale(1.035)}\
    .rutam-visual-card__step,.rutam-visual-card__current{position:absolute;z-index:2;left:12px;font-family:"DM Sans",sans-serif;font-size:8px;letter-spacing:.18em;text-transform:uppercase;padding:6px 8px;background:rgba(9,7,5,.82);border:1px solid var(--rutam-card-accent);color:#fff}\
    .rutam-visual-card__step{top:12px}\
    .rutam-visual-card__current{bottom:12px}\
    .rutam-visual-card__body{display:flex;flex-direction:column;justify-content:center;padding:22px 20px}\
    .rutam-visual-card__title{font-family:"Cormorant Garamond",Georgia,serif;font-size:21px;line-height:1.12;font-weight:500;color:#fff;margin:0 0 9px}\
    .rutam-visual-card__purpose{font-family:"DM Sans",sans-serif;font-size:12px;line-height:1.55;color:rgba(245,242,236,.56);margin:0 0 16px}\
    .rutam-visual-card__foot{display:flex;justify-content:space-between;align-items:center;gap:10px;margin-top:auto}\
    .rutam-visual-card__price{font-family:"DM Sans",sans-serif;font-size:12px;color:var(--rutam-card-accent)}\
    .rutam-visual-card__action{font-family:"DM Sans",sans-serif;font-size:8px;letter-spacing:.12em;color:#f5f2ec;text-transform:uppercase;text-align:right}\
    .rutam-system-gallery{margin-top:34px}\
    .rutam-system-gallery .rutam-visual-card{display:block;min-height:0;background:#120e0a}\
    .rutam-system-gallery .rutam-visual-card__media{height:340px}\
    .rutam-system-gallery .rutam-visual-card__body{min-height:170px;padding:24px}\
    .rutam-system-gallery .rutam-visual-card__title{font-size:25px}\
    @media(max-width:900px){\
      .rutam-product-rail{padding:24px 0 28px}\
      .rutam-product-rail__head{padding:0 20px;display:block}\
      .rutam-product-rail__note{display:block;margin-top:7px}\
      .rutam-product-rail__track,.rutam-system-gallery{display:flex;overflow-x:auto;gap:14px;scroll-snap-type:x mandatory;padding:0 20px 10px;scrollbar-width:none}\
      .rutam-product-rail__track::-webkit-scrollbar,.rutam-system-gallery::-webkit-scrollbar{display:none}\
      .rutam-visual-card{flex:0 0 82vw;max-width:390px;scroll-snap-align:center;grid-template-columns:43% 57%;min-height:190px}\
      .rutam-visual-card__media{min-height:190px}\
      .rutam-system-gallery{padding-left:0;padding-right:0}\
      .rutam-system-gallery .rutam-visual-card{flex-basis:78vw;max-width:360px}\
      .rutam-system-gallery .rutam-visual-card__media{height:360px}\
    }\
    @media(max-width:520px){\
      .rutam-product-rail__track{padding-left:16px;padding-right:16px}\
      .rutam-visual-card{flex-basis:86vw;grid-template-columns:44% 56%}\
      .rutam-visual-card__body{padding:18px 16px}\
      .rutam-visual-card__title{font-size:18px}\
      .rutam-system-gallery .rutam-visual-card{flex-basis:84vw}\
      .rutam-system-gallery .rutam-visual-card__media{height:330px}\
    }';

  var previousStyle = document.getElementById(style.id);
  if (previousStyle) previousStyle.remove();
  document.head.appendChild(style);
});
